/**
 * Reducer for the Preschool Curriculum admin slice (Phase 5).
 *
 * Mirrors spaceEntity exactly — uses the same helpers + AsyncSlot shape.
 * 4 entity-keyed AsyncSlots in the state tree, one per entity type.
 */
import {
  commonStructure,
  handleEntitiesUpdate,
  dataResponseHandler,
  dataFetchingHandler
} from './reducer.helper'

import * as types from '../types/preschoolEntity'

const initialState = {
  preschoolSkillData: commonStructure(),
  preschoolWeeklyThemeData: commonStructure(),
  preschoolWeeklySkillPlanData: commonStructure(),
  preschoolMonthlyThemeData: commonStructure(),
  preschoolAnnualLoData: commonStructure(),
  preschoolSpiralLoData: commonStructure()
}

const preschoolEntityReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PRESCHOOL_SKILL_DATA:
    case types.FETCH_PRESCHOOL_WEEKLY_THEME_DATA:
    case types.FETCH_PRESCHOOL_WEEKLY_SKILL_PLAN_DATA:
    case types.FETCH_PRESCHOOL_MONTHLY_THEME_DATA:
    case types.FETCH_PRESCHOOL_ANNUAL_LO_DATA:
    case types.FETCH_PRESCHOOL_SPIRAL_LO_DATA:
      return dataFetchingHandler(state, `${action.entity}Data`, action)

    case types.FETCH_PRESCHOOL_SKILL_DATA_SUCCESS:
    case types.FETCH_PRESCHOOL_WEEKLY_THEME_DATA_SUCCESS:
    case types.FETCH_PRESCHOOL_WEEKLY_SKILL_PLAN_DATA_SUCCESS:
    case types.FETCH_PRESCHOOL_MONTHLY_THEME_DATA_SUCCESS:
    case types.FETCH_PRESCHOOL_ANNUAL_LO_DATA_SUCCESS:
    case types.FETCH_PRESCHOOL_SPIRAL_LO_DATA_SUCCESS:
      return dataResponseHandler(state, `${action.entity}Data`, action)

    case types.UPDATE_PRESCHOOL_DATA_SUCCESS:
      return handleEntitiesUpdate(state, action)

    default:
      return state
  }
}

export { preschoolEntityReducer }
